import styles from "../HealthChat.module.css";
import { useState } from "react";
const SPECIALTIES = [
  { id: "gynecologist", label: "Gynecologist", emoji: "🫀", bg: "#fce4ec" },
  {
    id: "pregnancy",
    label: "Pregnancy / Maternity",
    emoji: "🤰",
    bg: "#fce4ec",
  },
  { id: "fertility", label: "Fertility Health", emoji: "🌸", bg: "#ede7f6" },
  { id: "hormonal", label: "Hormonal / PCOS", emoji: "♀️", bg: "#f3e5f5" },
  // { id: "diagnostic",    label: "Diagnostic / Lab Consult", emoji: "🔬", bg: "#e3f2fd" },
];

export default function SelectCareTypeScreen({
  onSelect,
  onBack,
  selectedCareType,
}) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  // const filtered = SPECIALTIES.filter((s) =>
  //   s.label.toLowerCase().includes(search.toLowerCase()),
  // );

  const filtered = SPECIALTIES.filter((s) => {
    const matchesSearch = s.label.toLowerCase().includes(search.toLowerCase());

    const matchesType = selectedCareType?.specialties
      ? selectedCareType.specialties.includes(s.id)
      : true;

    return matchesSearch && matchesType;
  });

  return (
    <div className={styles.selectCareScreen}>
      <button className={styles.selectCareBack} onClick={onBack}>
        ← Back
      </button>
      <div className={styles.selectCareTitle}>Select a Care Type</div>

      {/* Recommendation banner */}
      <div className={styles.selectCareBanner}>
        <span className={styles.selectCareBannerIcon}>🩺</span>
        <span>
          Based on your symptoms, we recommend a{" "}
          <strong>{selectedCareType?.label}</strong>.
        </span>
      </div>

      {/* Search */}
      {/* <div className={styles.selectCareSearchWrap}>
        <span className={styles.selectCareSearchIcon}>🔍</span>
        <input
          className={styles.selectCareSearch}
          placeholder="Search for a specialty..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div> */}

      <div className={styles.selectCareSearchWrap}>
        <span className={styles.selectCareSearchIcon}>🔍</span>

        <input
          className={styles.selectCareSearch}
          placeholder="Search for a specialty..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {search && (
          <div className={styles.selectCareDropdown}>
            {SPECIALTIES.filter((s) =>
              s.label.toLowerCase().includes(search.toLowerCase()),
            ).map((s) => (
              <div
                key={s.id}
                className={styles.selectCareDropdownItem}
                onClick={() => {
                  // setSearch(s.label);
                  // onSelect(s);
                  setSelected(s);
                  setSearch("");
                }}
              >
                <span>{s.emoji}</span>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Specialty grid */}
      <div className={styles.selectCareGrid}>
        {filtered.map((sp) => (
          <div
            key={sp.id}
            // className={styles.selectCareCard}
            className={`${styles.selectCareCard} ${
              selected?.id === sp.id ? styles.selectCareCardActive : ""
            }`}
            onClick={() => onSelect(sp)}
          >
            <div
              className={styles.selectCareIconCircle}
              style={{ background: sp.bg }}
            >
              <span className={styles.selectCareEmoji}>{sp.emoji}</span>
            </div>
            <div className={styles.selectCareLabel}>{sp.label}</div>
          </div>
        ))}
      </div>

      {selected && (
        <button
          className={styles.visitModelContinueBtn}
          onClick={() => onSelect(selected)}
        >
          Continue
        </button>
      )}
    </div>
  );
}
